import { AnimatedIntro, CustomBottomBar } from '@components';
import { Button, Container, CustomIcon, Typography, formationWelcome } from '@design-system';
import React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useFormationPageVM } from './useFormationPageVM';

export const FormationModulePage: React.FC = () => {
    const { navigate, steps } = useFormationPageVM();

    return (
        <Container className="formation-page" height="fill">
            <Container bordered="grey" center column padding="large" height="fill">
                <CustomIcon src={formationWelcome} alt="Formations" />
                <Typography intrinsic="h1">Bienvenue</Typography>
                <Typography intrinsic="h3" defaultSpacing>
                    sur la section formation
                </Typography>

                <AnimatedIntro steps={steps} />
            </Container>

            <CustomBottomBar>
                <Button
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={30}
                    onClick={() => {
                        navigate('/sante-securite/formations/list');
                    }}
                >
                    <Typography intrinsic="p">Commencer</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
